import(/* webpackMode: "eager" */ "/var/www/blcmusic/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/var/www/blcmusic/src/app/tv-portrait.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/blcmusic/src/components/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/blcmusic/src/components/PwaRegister.tsx");
